// Constants.
// -----------------------------------------------------------------------------
// Default values.
export const BADGE_DEFAULT_ARIAL_LABEL_CLOSE = 'close-button';
export const BADGE_DEFAULT_ICON_TITLE = 'start-icon-badge';
export const BADGE_DEFAULT_ICON_LOADING_TITLE = 'start-icon-loading';
export const BADGE_DEFAULT_LOADING = false;
export const BADGE_DEFAULT_MODE = 'light';
export const BADGE_DEFAULT_SIZE = 'm';
export const BADGE_DEAULT_VARIANT = 'hard';
// Mappings.
export const BADGE_ICON_SIZES = {
    l: 'xl',
    m: 'l',
    s: 'l',
    xs: 'l'
};
export const BADGE_PADDING_SIZES = {
    xs: {
        horizontal: 'm',
        vertical: '2xs',
        gap: 'xs'
    },
    s: {
        horizontal: 's',
        vertical: 'xs',
        gap: 's'
    },
    m: {
        horizontal: 'l',
        vertical: 's',
        gap: 's'
    },
    l: {
        horizontal: '2xl',
        vertical: 'l',
        gap: 's'
    }
};
//# sourceMappingURL=Badge.constants.js.map